module.exports = __webpack_public_path__ + "img/Ooops.f746e758.svg";